<template>
  <header id="header" class="header sticky-top" :class="{ 'header-scrolled': isHeaderScrolled }">
    <ModalCategoriaFiltroMobile />
    <!-- Top Bar -->

    <!-- Faixa discreta acima da busca, com links institucionais (Segurança,
         Contato, Garantia, Sobre) - some no mobile, onde tudo continua
         acessível pelo menu hambúrguer (.header-nav mais abaixo). -->
    <div class="header-top-links d-none d-xl-flex">
      <nav class="navmenu header-top-links-nav">
        <ul>
          <li v-for="pagina in paginasTopoCabecalho" :key="'topo-' + pagina.id">
            <a
              :href="'/' + pagina.slug"
              @click.prevent="$router.push('/' + pagina.slug)"
              >{{ pagina.title }}</a
            >
          </li>
        </ul>
      </nav>
    </div>

    <!-- Main Header -->
    <div class="main-header">
      <div class="mr-4 ml-4">
        <div
          class="d-flex align-items-center justify-content-between main-header-row"
        >
          <!-- Logo -->
          <a class="logo align-items-center show-on-mobile">
            <!-- Uncomment the line below if you also wish to use an image logo -->
            <!-- <img srcexample3.png" alt=""> -->
            <h1
              class="sitename mr-2"
              @click="$bvModal.show('categorias-filtro-global')"
            >
              <b-icon-list></b-icon-list>
            </h1>
          </a>

          <a href="/" class="logo d-flex align-items-center">
            <!-- Uncomment the line below if you also wish to use an image logo -->
            <!-- <img srcexample3.png" alt=""> -->
            <h1 class="sitename">
              <mx3-logo />
            </h1>
          </a>

          <!-- Search -->

          <!-- Navigation (versão mobile/hamburguer - a versão desktop fica
               na .header-category-bar, abaixo da busca) -->
          <div class="header-nav d-xl-none">
            <div class="position-relative">
              <nav id="navmenu" class="navmenu">
                <ul>
                  <li style="text-align: center !important" class="text-center nav-tab-item">
                    <a href="/" class="active text-center">Início</a>
                  </li>
                  <li class="dropdown categorias-container-2 nav-tab-item">
                    <a href="#">
                      <span class="text-muted">Categorias</span>
                      <i class="bi bi-chevron-down toggle-dropdown"></i>
                    </a>

                    <ul class="category-list m-1">
                      <li
                        v-for="(categoria, i) in categorias"
                        :key="i"
                        style="border-radius: 14px; margin-bottom: 5px"
                        class="cursor-pointer"
                        @click="filterByCategoria(categoria)"
                      >
                        <a class="f" style="padding: 10px 15px; display: block">
                          {{ categoria.nome }}
                        </a>
                      </li>
                    </ul>
                  </li>

                  <li class="dropdown nav-tab-item" v-if="servicos.length">
                    <a href="#"
                      ><span class="text-muted">Serviços</span>
                      <i class="bi bi-chevron-down toggle-dropdown"></i
                    ></a>
                    <ul>
                      <li v-for="(servico, i) in servicos" :key="i">
                        <a
                          @click="openServico(servico)"
                          class="cursor-pointer"
                          >{{ servico.titulo }}</a
                        >
                      </li>
                    </ul>
                  </li>

                  <li class="nav-tab-item" v-for="pagina in paginasInstitucionaisVisiveis" :key="pagina.id">
                    <a
                      class="text-muted"
                      :href="'/' + pagina.slug"
                      @click.prevent="$router.push('/' + pagina.slug)"
                      >{{ pagina.title }}</a
                    >
                  </li>
                </ul>
              </nav>
            </div>
          </div>
          <!-- Busca + Ordenar (mesclados num único campo): antes viviam
               soltos na página de Produtos; agora moram só aqui no
               cabeçalho e valem em qualquer página do site. O "Ordenar
               por" fica embutido como ícone do lado direito, dentro do
               próprio campo de busca (o <select> real fica transparente,
               sobreposto exatamente por cima do ícone, então continua
               100% funcional). -->
          <div class="header-search-sort">
            <i class="bi bi-search header-search-icon"></i>
            <input
              type="text"
              class="header-search-input"
              placeholder="Buscar produtos..."
              v-model="searchGlobal"
              @input="onSearchInput"
              @keyup.enter="applyHeaderFilters"
            />
            <i class="bi bi-sliders header-sort-icon-visual" aria-hidden="true"></i>
            <select
              class="header-sort-select-overlay"
              v-model="orderByGlobal"
              @change="applyHeaderFilters"
              aria-label="Ordenar por"
            >
              <option value="estoque">Ordenar por</option>
              <option value="nome">A a Z</option>
              <option value="valor">Menor Valor</option>
              <option value="valor+">Maior Valor</option>
              <option value="maisvendidos">Mais vendidos</option>
            </select>
          </div>

          <form
            v-if="false"
            class="search-form desktop-search-form"
            @submit.prevent="searchProducts"
          >
            <div class="input-group">
              <input
                type="text"
                class="form-control"
                placeholder="Buscar produtos"
                v-model="searchGlobal"
                @keyup.enter="searchProducts"
              />
              <button class="btn" type="submit" @click="searchProducts">
                <i class="bi bi-search"></i>
              </button>
            </div>
          </form>

          <!-- Actions -->
          <div
            class="header-actions d-flex align-items-center justify-content-end"
          >
            <!-- Mobile Search Toggle -->
            <!-- <button
              class="header-action-btn mobile-search-toggle d-xl-none"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#mobileSearch"
              aria-expanded="false"
              aria-controls="mobileSearch"
            >
              <i class="bi bi-search"></i>
            </button> -->

            <!-- ThemeSwitcher -->
            <a class="d-none d-md-block">
              <ThemeSwitcher />
            </a>

            <!-- Account -->
            <div class="dropdown account-dropdown" style="display:flex;align-items:center;">
              <button
                class="header-action-btn button-header-action-- text-muted desktop-header-btn"
                data-bs-toggle="dropdown"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  class="lucide lucide-user-icon lucide-user"
                >
                  <path d="M19 21v-2a4 4 0 0 0-4-4H9a4 4 0 0 0-4 4v2" />
                  <circle cx="12" cy="7" r="4" />
                </svg>
              </button>
              <AccountMenu />
            </div>


            <!-- Account -->
            <div class="dropdown account-dropdown" style="display:flex;align-items:center;">
              <button
                class="header-action-btn button-header-action-- text-muted desktop-header-btn"
                @click="$router.push('/cart')"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  class="lucide lucide-shopping-cart-icon lucide-shopping-cart"
                >
                  <circle cx="8" cy="21" r="1" />
                  <circle cx="19" cy="21" r="1" />
                  <path
                    d="M2.05 2.05h2l2.66 12.42a2 2 0 0 0 2 1.58h9.78a2 2 0 0 0 1.95-1.57l1.65-7.43H5.12"
                  />
                </svg>
                <span class="badge text-black-full" v-if="$store.state.carrinho.length">{{
                  $store.state.carrinho.length
                }}</span>
              </button>
            </div>

            <!-- Mobile Navigation Toggle -->
            <!-- <i class="mobile-nav-toggle d-xl-none bi bi-list me-0" @click="$util.redirectTo('/')  "></i> -->
          </div>
        </div>
      </div>
    </div>

    <!-- Faixa de categorias abaixo da busca (Início, Categorias, Projetos
         de Redes e Infraestrutura, Serviços) - versão desktop; some no
         mobile, onde tudo continua acessível pelo menu hambúrguer acima. -->
    <div class="header-category-bar d-none d-xl-block">
      <nav class="navmenu">
        <ul>
          <li class="nav-tab-item">
            <a
              href="/"
              :class="{ active: $route.path === '/' }"
              @click.prevent="$router.push('/')"
              >Início</a
            >
          </li>
          <li class="dropdown categorias-container-2 nav-tab-item">
            <a href="#" :class="{ active: $route.name === 'products' }">
              <span class="text-muted">Categorias</span>
              <i class="bi bi-chevron-down toggle-dropdown"></i>
            </a>

            <ul class="category-list m-1">
              <li
                v-for="(categoria, i) in categorias"
                :key="i"
                style="border-radius: 14px; margin-bottom: 5px"
                class="cursor-pointer"
                @click="filterByCategoria(categoria)"
              >
                <a class="f" style="padding: 10px 15px; display: block">
                  {{ categoria.nome }}
                </a>
              </li>
            </ul>
          </li>

          <li class="dropdown nav-tab-item" v-if="servicos.length">
            <a href="#"
              ><span class="text-muted">Serviços</span>
              <i class="bi bi-chevron-down toggle-dropdown"></i
            ></a>
            <ul>
              <li v-for="(servico, i) in servicos" :key="i">
                <a
                  @click="openServico(servico)"
                  class="cursor-pointer"
                  >{{ servico.titulo }}</a
                >
              </li>
            </ul>
          </li>

          <li class="nav-tab-item" v-for="pagina in paginasBarraCategoria" :key="'cat-' + pagina.id">
            <a
              class="text-muted"
              :class="{ active: $route.path === '/' + pagina.slug }"
              :href="'/' + pagina.slug"
              @click.prevent="$router.push('/' + pagina.slug)"
              >{{ pagina.title }}</a
            >
          </li>
        </ul>
      </nav>
    </div>

    <!-- Mobile Search Form -->
    <div class="collapse" id="mobileSearch">
      <div class="container">
        <form class="search-form" @submit.prevent="searchProducts">
          <div class="input-group">
            <input
              type="text"
              class="form-control"
              placeholder="Buscar produtos"
              v-model="searchGlobal"
              @keyup.enter="searchProducts"
            />
            <button class="btn" type="submit" @click="searchProducts">
              <i class="bi bi-search"></i>
            </button>
          </div>
        </form>
      </div>
    </div>
  </header>
</template>

<script>
import Login from "@/pages/Login.vue";
import ThemeSwitcher from "@/components/ThemeSwitcher";
import templateMixin from "../mixins/templateMixin";
import ModalCategoriaFiltroMobile from "./ModalCategoriaFiltroMobile";

export default {
  name: "Header",
  mixins: [templateMixin],
  components: { ThemeSwitcher, ModalCategoriaFiltroMobile },
  data() {
    return {
      searchGlobal: "",
      orderByGlobal: "valor+",
      categorias: [],
      servicos: [],
      paginasInstitucionais: [],
      searchDebounce: null,
      isHeaderScrolled: false,
    };
  },
  created() {
    this.$api.get("servico/").then((res) => {
      this.servicos = res.data;
      this.$forceUpdate();
    });
    // Carregar páginas institucionais para o menu dinâmico
    const syncUrl = window.location.origin + "/api/sync_institutional_pages.php?action=get_all";
    fetch(syncUrl)
      .then(r => r.json())
      .then((res) => {
        if (res.status === 'success' && res.pages) {
          this.paginasInstitucionais = res.pages;
        }
      }).catch(err => console.error("Erro ao carregar menu institucional:", err));
  },
  mounted() {
    // Inicializa as funcionalidades específicas do header
    this.initMobileNav();
    this.initMobileDropdowns();
    this.initSwiper();
    setTimeout(() => {
      this.searchGlobal = this.$route?.query?.q ?? "";
      this.orderByGlobal = this.$route?.query?.ordenar ?? "valor+";
      this.getCategorias();
    }, 500);

    // Faz apenas a barra com logomarca, busca, "Ordenar por" e os botões
    // de login/carrinho (.main-header) ficar fixa ao rolar, igual ao
    // e-commerce Import Mais Brasil - as faixas de cima (Segurança/
    // Contato/Garantia/Sobre) e de baixo (Início/Categorias/Projetos de
    // Redes) rolam normalmente com a página. Ver updateHeaderScrolled().
    this.updateHeaderScrolled();
    window.addEventListener('scroll', this.updateHeaderScrolled, { passive: true });
    window.addEventListener('resize', this.onHeaderResize);
    this.$nextTick(() => this.scheduleMainHeaderMeasurement());
    const mainHeader = this.$el.querySelector('.main-header');
    if (mainHeader && typeof ResizeObserver !== 'undefined') {
      this._mainHeaderResizeObserver = new ResizeObserver(() => {
        this.scheduleMainHeaderMeasurement();
      });
      this._mainHeaderResizeObserver.observe(mainHeader);
    }
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.updateHeaderScrolled);
    window.removeEventListener('resize', this.onHeaderResize);
    if (this._mainHeaderResizeObserver) {
      this._mainHeaderResizeObserver.disconnect();
    }
    if (this._mainHeaderMeasureRaf != null) {
      window.cancelAnimationFrame(this._mainHeaderMeasureRaf);
    }
    if (this._mainHeaderMeasureTimer != null) {
      window.clearTimeout(this._mainHeaderMeasureTimer);
    }
  },
  computed: {
    paginasInstitucionaisVisiveis() {
      // Páginas que pertencem exclusivamente ao rodapé (Termos, Privacidade e Cookies)
      // não devem ser exibidas no menu do cabeçalho.
      const slugsExclusivosRodape = ['termos', 'privacidade', 'cookies'];
      // Retorna apenas as páginas com status published que não sejam exclusivas do rodapé
      return this.paginasInstitucionais.filter(
        (p) =>
          (p.status === 'published' || !p.status) &&
          !slugsExclusivosRodape.includes(p.slug)
      );
    },
    // Divide as páginas institucionais entre a faixa de cima (acima da
    // busca) e a barra de categorias (abaixo da busca), no layout novo
    // inspirado no e-commerce Import Mais Brasil. Segurança/Contato/
    // Garantia/Sobre vão para cima; qualquer outra página institucional
    // (ex.: Projetos de Redes e Infraestrutura) vai para a barra de baixo,
    // junto com Início/Categorias - assim uma página institucional nova,
    // criada no futuro, continua aparecendo em algum lugar do menu.
    paginasTopoCabecalho() {
      const slugsTopo = ['seguranca', 'contato', 'garantia', 'sobre'];
      return this.paginasInstitucionaisVisiveis.filter((p) => slugsTopo.includes(p.slug));
    },
    paginasBarraCategoria() {
      const slugsTopo = ['seguranca', 'contato', 'garantia', 'sobre'];
      return this.paginasInstitucionaisVisiveis.filter((p) => !slugsTopo.includes(p.slug));
    }
  },
  methods: {
    // Mede a altura da faixa de cima para decidir quando a .main-header
    // deve virar position:fixed, e mede a própria altura da .main-header
    // para reservar esse espaço na barra de categorias logo abaixo -
    // evitando qualquer "pulo" de conteúdo no momento da troca. Mesma
    // técnica usada no e-commerce Import Mais Brasil.
    updateHeaderScrolled() {
      const topLinks = this.$el.querySelector('.header-top-links');
      const threshold = topLinks ? topLinks.offsetHeight : 0;

      const shouldBeScrolled = window.scrollY > threshold;
      if (this.isHeaderScrolled !== shouldBeScrolled) {
        this.isHeaderScrolled = shouldBeScrolled;
        // Em um F5 com a rolagem restaurada, a classe altera a altura da
        // barra. Aguarda o DOM reativo antes de medir para não reservar a
        // altura anterior e deixar uma folga abaixo do cabeçalho.
        this.$nextTick(() => this.scheduleMainHeaderMeasurement());
      }
    },
    onHeaderResize() {
      this.updateHeaderScrolled();
      this.scheduleMainHeaderMeasurement();
    },
    scheduleMainHeaderMeasurement() {
      if (this._mainHeaderMeasureRaf != null) {
        window.cancelAnimationFrame(this._mainHeaderMeasureRaf);
      }
      if (this._mainHeaderMeasureTimer != null) {
        window.clearTimeout(this._mainHeaderMeasureTimer);
      }

      this._mainHeaderMeasureRaf = window.requestAnimationFrame(() => {
        this._mainHeaderMeasureRaf = null;
        this.measureMainHeaderHeight();
      });
      // ResizeObserver acompanha transições de logo/layout; este passe
      // final também cobre o tamanho estabilizado sem esse recurso.
      this._mainHeaderMeasureTimer = window.setTimeout(() => {
        this._mainHeaderMeasureTimer = null;
        this.measureMainHeaderHeight();
      }, 260);
    },
    measureMainHeaderHeight() {
      const mainHeader = this.$el && this.$el.querySelector('.main-header');
      if (!mainHeader) return;
      const altura = Math.ceil(mainHeader.getBoundingClientRect().height);
      this.$el.style.setProperty('--main-header-height', altura + 'px');
    },
    openServico(servico) {
      window.open(`/service?id=${servico.id}`, "_self");
    },
    filterByCategoria(categoria) {
      localStorage.setItem("filterCategoria", JSON.stringify(categoria));
      const catId = categoria?.id ?? categoria;
      
      // Se já estiver na página de produtos, a navegação fluida é tratada pelo watcher do Products.vue
      // Se não estiver, redireciona para a página de produtos com a categoria selecionada
      if (this.$route.name === 'products') {
        this.$router.push({
          query: { ...this.$route.query, categoria: catId, subcategoria: undefined, filtroproduto: undefined }
        }).catch(() => {});
      } else {
        this.$router.push({
          path: '/products',
          query: { categoria: catId }
        });
      }
    },

    getCategorias() {
      console.log("pegando categorias", this.$api);
      this.$api.getCategorias().then((res) => {
        this.categorias = res.data;

        this.$store.state.categoriasProdutos = {};
        for (const categoria of this.categorias) {
          this.$store.state.categoriasProdutos[categoria.id] = categoria;
        }
      });
    },
    searchProducts() {
      let url = `/products`;

      if (this.searchGlobal) {
        url = `/products?q=${this.searchGlobal}`;
      }

      localStorage.removeItem("filterCategoria");

      window.location.href = url;
      // window.location.reload();
    },
    // Campo de busca + ordenação mesclados no cabeçalho (agora a única
    // instância desses controles no site - antes existiam soltos, e
    // duplicados, na página de Produtos). Atualizam a query da rota:
    // se já estiver em /products, o Products.vue reage via seu watcher de
    // $route; caso contrário, navega para lá com os filtros aplicados.
    onSearchInput() {
      if (this.searchDebounce) clearTimeout(this.searchDebounce);
      this.searchDebounce = setTimeout(() => this.applyHeaderFilters(), 400);
    },
    applyHeaderFilters() {
      const query = { ...this.$route.query };
      if (this.searchGlobal) {
        query.q = this.searchGlobal;
      } else {
        delete query.q;
      }
      if (this.orderByGlobal && this.orderByGlobal !== "estoque") {
        query.ordenar = this.orderByGlobal;
      } else {
        delete query.ordenar;
      }
      localStorage.removeItem("filterCategoria");
      if (this.$route.name === "products") {
        this.$router.push({ query }).catch(() => {});
      } else {
        this.$router.push({ path: "/products", query }).catch(() => {});
      }
    },
  },
};
</script>


<style lang="scss">

  @media (min-width: 768px) {
  .account-dropdown{
  scale: 1;
}
  }

/* Logomarca do cabeçalho desktop compacta para acompanhar a redução do
   campo de busca. Regra não-scoped porque a <img> vive no componente
   filho <mx3-logo> e seletores scoped não a alcançam. Rodapé e demais
   logos do site continuam inalterados. */
@media (min-width: 769px) {
  #header .main-header .logo .logo-site-img {
    height: 72px !important;
    position: relative;
    z-index: 2;
  }
}

/* Estado inicial: a logomarca avança visualmente sobre a barra inferior. */
@media (min-width: 1200px) {
  #header:not(.header-scrolled) .main-header .logo .logo-site-img {
    height: 88px !important;
    transform: translateY(0);
    transition: height 0.2s ease, transform 0.2s ease;
  }
}

/* Barra fixa ao rolar (igual ao e-commerce Import Mais Brasil): apenas a
   .main-header (logomarca, busca, "Ordenar por" e os botões de login/
   carrinho) permanece visível/fixa - a faixa de cima (Segurança/Contato/
   Garantia/Sobre) e a faixa de baixo (Início/Categorias/Projetos de Redes)
   rolam normalmente com a página. position:sticky sozinho não funciona
   aqui porque o <header> (onde a barra "gruda") é curto - só a altura das
   3 faixas somadas - então o efeito se perderia quase imediatamente ao
   rolar. Por isso a classe .header-scrolled é alternada via JS (ver
   updateHeaderScrolled() no <script>) e aplicamos position:fixed apenas
   na .main-header quando ativa. */
@media (min-width: 1200px) {
  .header-scrolled .header-top-links {
    display: none !important;
  }

  .header-scrolled .main-header {
    position: fixed !important;
    top: 0;
    left: 0;
    right: 0;
    z-index: 1030;
  }

  .header-scrolled .main-header .logo .logo-site-img {
    height: 56px !important;
    transform: translateY(0);
    transition: height 0.2s ease;
  }

  /* Reserva exatamente a altura da .main-header (medida via JS) para que
     a faixa de categorias não "pule" para cima no instante em que a
     barra de cima vira fixed e sai do fluxo normal do documento. */
  .header-scrolled .header-category-bar {
    margin-top: var(--main-header-height, 64px);
  }
}

.header-action-btn {
  border-radius: 10px !important;
  width: 65px !important;
  height: 65px !important;
  text-align: center !important;
  /* Cor da borda vem do tema ativo (a borda branca translúcida era
     invisível no tema claro). */
  border: 0.1px solid var(--mx3-style-border, #ffffff1a) !important;
}

.header-action-btn .badge {
  position: absolute;
  top: 2px;
  right: 2px;
  color: rgb(255, 255, 255);
  font-size: 10px;
  font-weight: 700;
  min-width: 18px;
  text-align: center;
  background: linear-gradient(135deg, rgb(0, 217, 255), rgb(10, 97, 201));
  border-radius: 10px;
  padding: 2px 6px;
}
.header-action-btn .badge:hover {
  color: var(--primary) !important;
}

/* Logomarca do cabeçalho desktop de volta ao tamanho ORIGINAL do tema
   (85px, regra global do Logo.vue para telas >= 769px) - a redução para
   40px feita na iteração anterior deixou a marca pequena demais (pedido
   de reversão). Nenhuma regra local aqui: vale a do Logo.vue. */

.navmenu a {
  font-weight: 600 !important;
}

.navmenu a {
  font-weight: 600;
  color: #064089;
  transition: all 0.3s ease;
  position: relative;
}

/* .navmenu a:before {
  content: "";
  position: absolute;
  bottom: 5px;
  left: 0;
  right: 0;
  height: 2px;
  background: var(--mx3-style-primary, #00d9ff);
  transform: scaleX(0);
  transition: transform 0.3s ease;
} */

.navmenu a.active:before,
.navmenu a:hover:before {
  transform: scaleX(1);
}

.navmenu a.active,
.navmenu a:hover {
  color: var(--mx3-style-primary, #00d9ff);
}
.navmenu .dropdown ul {
  background: var(--mx3-style-bg-card, #161b26) !important;
  border-radius: 15px !important;
  padding-right: 5px !important;
  padding-left: 5px !important;
}
.navmenu .dropdown ul li {
  margin-left: 5px;
  transition: all 1s ease;
}
.navmenu .dropdown ul li:hover {
  margin-left: 15px;
  transition: all 1s ease;
}
</style>

<style scoped lang="scss">
.categorias-container-2 {
  li {
    background-color: #afafaf !important;
  }
  .bg-white:not(.is-active) {
    background-color: white !important;
    border: solid #afafaf60 0.1px !important;
    color: black !important;
  }
  li:not(.is-active) {
    background: var(--mx3-style-bg-card, #161b26) !important;
    border: 0.5px solid #e5e5e520 !important;
    span {
      /* Cor de texto do tema ativo (o hex claro fixo ficava invisível
         sobre o dropdown branco do tema claro). */
      color: var(--mx3-style-text-secondary, #e5e5e5) !important;
    }
  }
  li:not(.is-active):hover {
    background: var(--mx3-style-bg-card, #161b26) !important;
    border: 0.5px solid var(--mx3-style-primary, #00d9ff) !important;
    span {
      padding-left: 15px !important;
      text-shadow: 2px 2px 15px black !important;
      color: var(--mx3-style-primary, #00d9ff) !important;

      transition: all 0.3s ease;
    }
  }
  .is-active {
    background: transparent !important;
    border: 0.5px solid var(--mx3-style-primary, #00d9ff) !important;
    span {
      text-shadow: 5px 5px 15px black !important;
      color: var(--mx3-style-primary, #00d9ff) !important;
    }
  }
  /*.input-rounded-class*/
  .input-rounded-class {
    border-radius: 14px !important;
    border-top-right-radius: 14px !important;
    border-bottom-right-radius: 14px !important;
    background: var(--mx3-style-input-bg, #1b2230) !important;
    background-color: var(--mx3-style-input-bg, #1b2230) !important;
  }
  /*.input-rounded-class*/
  .button-rounded-class {
    border-top-left-radius: 14px !important;
    border-bottom-left-radius: 14px !important;
    border-radius: 14px !important;
    padding-right: 12px !important;
    height: 35px !important;
    scale: 0.9 !important;
    margin-top: 1px !important;
    right: 47px !important;
    position: relative !important;
  }
  /*.input-rounded-class*/
  .input-rounded-class2 {
    background: var(--mx3-style-input-bg, #1b2230) !important;
    background-color: var(--mx3-style-input-bg, #1b2230) !important;
    border-radius: 14px !important;
    /* border-top-left-radius: 0;
  border-bottom-left-radius: 0;
  padding-right:14px; */
  }

  /* Estilos mantidos, apenas para contexto */
  .cursor-pointer {
    cursor: pointer !important;
  }

  /* --- Estilos para os Filtros Laterais --- */

  .filter-group {
    padding: 10px !important;
    border-radius: 8px !important;
  }

  .filter-title {
    font-size: 1.1rem !important;
    font-weight: bold !important;
    color: #343a40 !important;
    border-bottom: 1px solid #eee !important;
    padding-bottom: 5px !important;
  }

  .category-list {
    padding-left: 0 !important;
  }

  .filter-item:hover {
    margin-left: 5px !important;
    transition: all 0.3s ease !important;
  }

  .filter-item {
    display: flex !important;
    justify-content: space-between !important;
    align-items: center !important;
    padding: 8px 10px !important;
    margin-bottom: 3px !important;
    border-radius: 5px !important;
    transition: background-color 0.2s, color 0.2s !important;
    font-size: 0.95rem !important;
    color: #555 !important;
  }

  .filter-item:hover:not(.is-active) {
    background-color: #f0f0f020 !important;
    color: #333 !important;
  }

  .filter-item.is-active {
    background-color: var(--primary) !important;
    color: white !important;
    font-weight: bold !important;
  }

  .subcategory-list .filter-item,
  .product-filter-list .filter-item {
    /* Estilo similar para o novo filtro */
    padding-left: 20px !important;
    font-size: 0.9rem !important;
  }

  /* --- Esconder/Mostrar elementos para desktop e mobile --- */
  @media (max-width: 767.98px) {
    .hide-on-mobile {
      display: none !important;
    }
    .show-on-mobile {
      display: block !important;
    }
  }

  @media (min-width: 768px) {
    .show-on-mobile {
      display: none !important;
    }
  }

  #products-container-custom {
    max-width: 80% !important;
  }
  #produto-item- {
    max-width: 300px !important;
    min-width: 280px !important;
  }

  @media (max-width: 768px) {
    #products-container-custom {
      width: 100% !important;
      max-width: 100% !important;
    }
    #produto-item- {
      width: 50% !important;
      max-width: unset !important;
      min-width: unset !important;
      scale: 0.9 !important;
      padding: 0.1px !important;
    }
    #produto-item- > div {
      margin: 1px !important;
    }
    #produto-item- > button > small {
      font-size: 5px !important;
    }
  }
  .filtro-text-color {
    color: black !important;
  }
  .category-name {
    padding: 10px !important;
    color: #ffffff50 !important;
  }
  .category-name:hover {
    padding: 10px !important;
  }
  .form-control {
    border: 1px solid #afafaf40 !important;
  }
  .form-control:focus {
    border: var(--mx3-style-primary, #00d9ff) solid 2px !important;
    box-shadow: unset !important;
  }
}
#header .main-header {
  border-bottom: transparent !important;
}

.button-header-action-- {
  width: 40px !important;
  height: 40px !important;
  transition: transform 0.2s ease !important;
  padding: 0 !important;
  min-width: 40px !important;
  min-height: 40px !important;
}

.button-header-action--:hover {
  transform: translateY(-2px) !important;

  /* Cor de fundo do hover vinda do tema ativo (no tema claro o hex fixo
     #111827 do tema escuro virava um blocão escuro ao passar o mouse). */
  background: var(--mx3-style-bg-card-hover, #111827) !important;
  border: var(--mx3-style-primary, #00d9ff) solid 0.5px !important;
}

/* Desktop: botões Login e Carrinho alinhados com o navmenu */
@media (min-width: 1200px) {
  .desktop-header-btn {
    display: flex !important;
    justify-content: center !important;
    align-items: center !important;
    width: 44px !important;
    height: 44px !important;
    min-width: 44px !important;
    min-height: 44px !important;
    padding: 0 !important;
    border-radius: 8px !important;
    transition: all 0.2s ease !important;
  }
  .header-actions {
    gap: 6px !important;
    align-items: center !important;
  }
  .account-dropdown {
    margin-left: 0 !important;
    margin-top: 0 !important;
    scale: 1 !important;
  }
}



/* Campo de busca + ordenação mesclados: "Ordenar por" fica embutido como
   ícone do lado direito, dentro do próprio campo de busca (mesmo padrão
   usado no e-commerce de referência), nas cores do tema MX3 ativo. */
.header-search-sort {
  position: relative;
  display: flex;
  align-items: center;
  flex: 1 1 auto;
  min-width: 220px;
  max-width: 520px;
  margin: 0 16px;
  gap: 8px;
  padding: 0 40px 0 14px;
  border: 1px solid var(--mx3-style-primary, #00d9ff);
  border-radius: 22px;
  background: var(--mx3-style-bg-card, #161b26);
  height: 40px;
}

.header-search-sort .header-search-icon {
  flex: 0 0 auto;
  color: var(--mx3-style-text-muted, rgba(255,255,255,0.5));
  font-size: 0.9rem;
}

.header-search-sort .header-search-input {
  flex: 1 1 auto;
  min-width: 0;
  height: 100%;
  padding: 0;
  border: none;
  background: transparent;
  color: var(--mx3-style-text-primary, #fff);
  font-size: 0.88rem;
  outline: none;
}

.header-search-sort .header-search-input::placeholder {
  color: var(--mx3-style-text-muted, rgba(255,255,255,0.45));
}

.header-search-sort .header-sort-icon-visual {
  position: absolute;
  top: 50%;
  right: 14px;
  color: var(--mx3-sort-icon-color, var(--mx3-style-primary, #00d9ff));
  font-size: 0.95rem;
  line-height: 1;
  pointer-events: none;
  transform: translateY(-50%);
}

/* O <select> real fica invisível, sobreposto exatamente sobre o ícone
   acima - continua 100% funcional (abre as opções normalmente), só que
   visualmente parece um ícone dentro do campo de busca. O <select> em si
   fica com opacity:0, mas a LISTA DE OPÇÕES que o navegador abre ao
   clicar é renderizada pelo sistema operacional/navegador usando o
   "color"/"background-color" do próprio elemento - por isso usamos
   variáveis dedicadas (--mx3-sort-menu-bg / --mx3-sort-menu-text) em vez
   de reaproveitar a cor de destaque/preto fixo: agora a tela
   "Personalizar E-commerce" tem campos próprios para o fundo e o texto
   dessa lista, então o admin pode garantir contraste mesmo trocando
   outras cores do tema. */
.header-search-sort .header-sort-select-overlay {
  position: absolute;
  top: 0;
  right: 0;
  width: 34px;
  height: 100%;
  border: none;
  margin: 0;
  padding: 0;
  opacity: 0;
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  cursor: pointer;
  color: var(--mx3-sort-menu-text, #000000);
  background-color: var(--mx3-sort-menu-bg, var(--mx3-style-primary, #00d9ff));
}

.header-search-sort .header-sort-select-overlay option {
  color: var(--mx3-sort-menu-text, #000000);
  background-color: var(--mx3-sort-menu-bg, var(--mx3-style-primary, #00d9ff));
  font-weight: 600;
}

@media (max-width: 991.98px) {
  .header-search-sort {
    min-width: 130px;
    margin: 0 10px;
  }
}

/* ---- Faixas de cima e de baixo (layout inspirado no e-commerce Import
   Mais Brasil), com a paleta MX3: as cores do texto/hover/dropdown vêm
   das MESMAS variáveis (--nav-color, --nav-hover-color, etc.) já usadas
   pelo .navmenu original, herdadas automaticamente por estarem dentro de
   um <nav class="navmenu"> igual ao de sempre - só a moldura/posição ao
   redor é nova. ---- */
/* Fundo preto solicitado para a faixa de cima (Sobre/Segurança/Garantia/
   Contato) - antes herdava a cor de fundo geral do tema (var(--background-
   color)), agora fica fixa em preto independente do tema claro/escuro
   ativo. Tamanho/tipografia/espaçamento (padding, gap, font-size) seguem
   os mesmos valores do e-commerce de referência (Import Mais Brasil), só
   a cor de fundo e a paleta de texto continuam sendo as do tema MX3. */
.header-top-links {
  width: 100%;
  background: #000000 !important;
  border-bottom: 1px solid color-mix(in srgb, var(--default-color, #000), transparent 92%);
}

.header-top-links-nav {
  /* .header-top-links é flex (d-xl-flex), então este <nav> vira um item
     flex e, por padrão, encolhe para o tamanho do próprio conteúdo (os 4
     links) em vez de ocupar a largura toda da faixa - por isso o
     "justify-content:center" no <ul> abaixo não tinha nenhum efeito
     visível (a caixa do <ul> já era do tamanho exato do conteúdo, não
     havia espaço sobrando para redistribuir). Forçando o <nav> a ocupar
     100% da faixa, o <ul> passa a ter espaço de verdade para centralizar
     os links dentro dele. */
  width: 100%;
  flex: 1 1 100%;
}

.header-top-links-nav ul {
  display: flex !important;
  justify-content: center;
  gap: 34px;
  width: 100%;
  padding: 4px 24px;
}

.header-top-links-nav a {
  padding: 0 !important;
  font-size: 0.72rem !important;
  font-weight: 500 !important;
  letter-spacing: 0.05em;
  text-transform: uppercase;
  color: var(--mx3-style-text-muted, rgba(255, 255, 255, 0.55)) !important;
}

.header-top-links-nav a:hover {
  color: var(--mx3-style-primary, #00d9ff) !important;
}

/* Faixa de baixo (Início/Categorias/Projetos de Redes e Infraestrutura):
   mesmo fundo da linha da logomarca (.main-header usa var(--nav-
   background) - ver regra "​.header .main-header" no css/base.css do
   tema), para que as duas faixas fiquem visualmente unificadas, como no
   e-commerce de referência (onde .header-category-bar e .main-header
   usam a mesma cor de fundo). Tipografia/espaçamento (font-size 0.92rem,
   font-weight 600, gap 40px, padding 10px verticais, sublinhado no hover/
   ativo) seguem os mesmos valores do e-commerce de referência, mas com as
   cores do tema MX3 (var(--mx3-style-primary) em vez da cor laranja fixa
   do e-commerce de referência). */
.header-category-bar {
  width: 100%;
  background-color: var(--nav-background, #111D2F) !important;
}

.header-category-bar .navmenu > ul {
  display: flex !important;
  justify-content: center;
  align-items: center;
  gap: 40px;
  width: 100%;
  padding: 6px 0;
}

.header-category-bar .navmenu > ul > li > a {
  position: relative;
  padding: 4px 0 !important;
  font-size: 0.92rem !important;
  font-weight: 600 !important;
}

.header-category-bar .navmenu > ul > li > a::after {
  content: "";
  position: absolute;
  left: 0;
  right: 0;
  bottom: -1px;
  height: 2px;
  background: var(--mx3-style-primary, #00d9ff);
  opacity: 0;
  transform: scaleX(0);
  transition: opacity 0.2s ease, transform 0.2s ease;
}

.header-category-bar .navmenu > ul > li > a:hover::after,
.header-category-bar .navmenu > ul > li > a.active::after {
  opacity: 1;
  transform: scaleX(1);
}

/* Compactação vertical das duas faixas do cabeçalho desktop (pedido):
   reduz a altura da faixa da logomarca/busca/botões e da faixa Início/
   Categorias/Projetos de Redes, mantendo todos os elementos centrados
   verticalmente dentro de cada faixa, para otimizar o espaço vertical. */

/* Faixa da logomarca: container flex centrado verticalmente, sem respiro
   vertical adicional. A logo compacta passa a ser o elemento mais alto. */
.main-header {
  display: flex;
  align-items: center;
  padding-top: 0 !important;
  padding-bottom: 0 !important;
  position: relative;
  z-index: 2;
  overflow: visible !important;
}

.main-header > div {
  flex: 1 1 auto;
  min-width: 0;
}

/* A regra da altura da logomarca no cabeçalho ficou no bloco NÃO-scoped
   acima (<style lang="scss"> sem "scoped"), porque a <img> está dentro do
   componente filho <mx3-logo> e seletores scoped não a alcançam. */

/* Campo de busca com a altura solicitada. Como a logo também foi compactada
   para 56px, o espaço acima e abaixo do campo diminui sem alterar sua
   funcionalidade, a ordenação embutida ou o alinhamento dos botões. */
.header-search-sort {
  height: 36px;
}

@media (min-width: 1200px) {
  .desktop-header-btn {
    width: 40px !important;
    height: 40px !important;
    min-width: 40px !important;
    min-height: 40px !important;
  }
}

/* Faixa de baixo (Início/Categorias/Projetos de Redes): paddings e
   fonte reduzidos; o <ul> já é flex com align-items:center, então os
   links continuam centrados verticalmente na faixa mais fina. */
.header-category-bar .navmenu > ul {
  padding: 2px 0;
  gap: 32px;
}

.header-category-bar .navmenu > ul > li > a {
  padding: 2px 0 !important;
  font-size: 0.85rem !important;
}

/* Centralização horizontal EXATA na tela (pedido): a linha da faixa da
   logomarca vira um grid de 3 colunas com laterais iguais (1fr) - logo
   encostada à esquerda, campo de busca no centro exato da tela e os
   botões de login/carrinho encostados à direita. No flex anterior a
   busca ficava deslocada de lado (as larguras da logo e dos botões são
   diferentes). align-items:center mantém tudo centrado verticalmente na
   faixa compactada; com a barra fixa ao rolar (.header-scrolled) o
   centro também se mantém. */
@media (min-width: 1182px) {
  .main-header-row {
    display: grid !important;
    grid-template-columns: 1fr minmax(220px, 520px) 1fr;
    align-items: center;
  }
  .main-header-row .logo {
    justify-self: start;
  }
  .main-header-row .header-search-sort {
    width: 100%;
    margin: 0;
  }
  .main-header-row .header-actions {
    justify-self: end;
  }
}

/* A altura estrutural da faixa é independente da altura visual da logo:
   assim o campo de busca permanece com apenas 10px de respiro acima/abaixo,
   enquanto a marca pode avançar sobre a barra de navegação inferior. */
@media (min-width: 1200px) {
  #header .main-header-row {
    height: 56px;
    min-height: 56px;
  }

  #header .main-header-row > .logo {
    position: relative;
    height: 56px;
    min-height: 56px;
    align-self: center;
    z-index: 3;
  }

  #header:not(.header-scrolled) .main-header-row > .logo .logo-site-img {
    position: absolute;
    /* Posição da logomarca grande (antes de rolar a página): ajustável em
       Gerenciador > Personalizar > "Logomarca do cabeçalho". Padrão: -16px / 0. */
    top: var(--mx3-logo-top, -16px);
    left: var(--mx3-logo-left, 0px);
    height: 88px !important;
    transform: none;
  }

  #header.header-scrolled .main-header-row > .logo .logo-site-img {
    position: absolute;
    top: 0;
    left: 0;
    height: 56px !important;
    transform: none;
  }
}

</style>
